import { useCallback, useState } from 'react';

import { getDownloadCustomPacingReportRequest } from '../../../../../apis/campaignGraphqlManager/customPacing';
import { downloadFile } from '../../../../../apis/util/downloadFile';
import type { DownloadFileError } from '../../../../../apis/util/downloadFileError';
import { openErrorToastAlert } from '../../../../../common/ToastAlert/toastAlert';
import { CUSTOM_PACING_REPORT_FILE_TYPE } from '../constants';

export type UseDownloadCustomPacingReport = {
  loading: boolean;
  downloadReport: () => Promise<void>;
};

export const useDownloadCustomPacingReport = (reportId: string, reportName: string): UseDownloadCustomPacingReport => {
  const [loading, setLoading] = useState<boolean>(false);

  const downloadReportRequest = useCallback(() => getDownloadCustomPacingReportRequest(reportId), [reportId]);

  const downloadReport = useCallback(async (): Promise<void> => {
    setLoading(true);

    const filename = `cp-report-${reportName}-${reportId}.csv`;

    try {
      await downloadFile(downloadReportRequest, filename, CUSTOM_PACING_REPORT_FILE_TYPE);
    } catch (e) {
      const error: DownloadFileError = e;
      openErrorToastAlert(error.name, error.message);
    } finally {
      setLoading(false);
    }
  }, [downloadReportRequest, reportId, reportName]);
  return {
    loading,
    downloadReport,
  };
};
